// extracted by mini-css-extract-plugin
module.exports = {"FormRow":"VendorCompanyModal_FormRow__HbIW2","FormCol":"VendorCompanyModal_FormCol__3XdTe"};